import {
  BrowserCacheLocation,
  Configuration,
  InteractionType,
  LogLevel,
} from '@azure/msal-browser';
import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.msalConfig.clientId,
    authority: environment.msalConfig.authority,
    redirectUri: environment.msalConfig.redirectUri,
    postLogoutRedirectUri: environment.msalConfig.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel, message) {
        switch (logLevel) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(`${environment.backendBaseUrl}/*`, [
    `api://${environment.backendClientId}/access_as_user`,
  ]);
  protectedResourceMap.set(`${environment.graphBaseUrl}/directoryObjects/*`, [
    'Group.Read.All',
  ]);
  protectedResourceMap.set(`${environment.graphBaseUrl}/me`, ['User.Read']);
  protectedResourceMap.set(`${environment.graphBaseUrl}/groups/*`, [
    'Group.Read.All',
  ]);
  protectedResourceMap.set(`${environment.graphBaseUrl}/users`, [
    'User.Read.All',
  ]);
  protectedResourceMap.set(`${environment.graphBaseUrl}/sites/*`, [
    'Sites.ReadWrite.All',
  ]);
  protectedResourceMap.set(`${environment.loggingBaseUrl}/*`, [
    `api://${environment.loggingClientId}/access_as_user`,
  ]);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
